import api from './api.service'

export const exportConfigurationService = {
    list,
    get,
    save,
    update,
    _delete,
    getExportConfigurations
};

const BASE_URL = '/exportConfigurations'

function list(max) {
    return api.get(BASE_URL, {max: max || 100, sort: 'id', order: 'asc'})
}

function get(id) {
    return api.get(BASE_URL + '/' + id)
}

function save(exportConfiguration) {
    return api.post(BASE_URL, exportConfiguration)
}

function update(id, exportConfiguration) {
    return api.put(BASE_URL + "/" + id, exportConfiguration)
}

function _delete(id) {
    return api.delete(BASE_URL + "/" + id)
}

function getExportConfigurations() {
    return api.get("/exportConfiguration/getExportConfigurations")
}
